import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "ALTER_PICKING_" }
);

export interface AlterPickingState extends IState {}

const INITIAL_STATE: AlterPickingState = {
  loading: false,
  error: null,
};

const request = (state: AlterPickingState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: AlterPickingState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: AlterPickingState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const alterPicking = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const AlterPickingTypes = Types;
export const AlterPickingActions = Creators;
